/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import api from '@redux/apis/baseApi'
import { API_RESOURCE } from '@constants/api'

const CACHE_NAMES = ['ExternalID'] as const

const externalIDApi = api.injectEndpoints({
  endpoints: build => ({
    getExternalID: build.query<Response.ExternalID, void>({
      query: () => ({
        url: API_RESOURCE.EXTERNAL_ID,
      }),
    }),
  }),
})

externalIDApi.enhanceEndpoints({
  addTagTypes: CACHE_NAMES,
  endpoints: {
    getExternalID: {
      providesTags: CACHE_NAMES,
    },
  },
})

export const { useGetExternalIDQuery } = externalIDApi

export default externalIDApi
